export const CONSULTATION_COPY = {
  label: '30-Minute Free Consultation',
  book: 'Book 30-Minute Free Consultation',
  bookYour: 'Book Your 30-Minute Free Consultation',
  bookA: 'Book a 30-Minute Free Consultation',
  bookAUpper: 'Book A 30-Minute Free Consultation',
  start: 'Start 30-Minute Free Consultation',
  startWith: 'Start with a 30-Minute Free Consultation',
  scheduleOne: 'Choose one to schedule a 30-minute free consultation.',
  journeyStep:
    'Intake Questionnaire → Book a 30-Minute Free Consultation → Book Your Session → Fill Out Client Participation Agreement → Session(s) → Follow-Up',
  durationOnline:
    "The free consultation is a 30-minute online session where you'll meet with your potential practitioner. Both you and the practitioner will decide if you're a good fit to work together. If it's not the right match, you're free to choose another practitioner.",
  intro:
    'A 30-minute free, confidential consultation is a gentle first step toward clarity and positive change. We’ll listen, answer your questions, understand your goals, and outline simple next steps—no pressure, no obligation.',
  startVideoConsultation: 'Start Free 30-Minute Video Consultation',
};
